import { Button, Text, VStack, Heading, Box } from '@primerai/thread';
import { LoginFeedback } from './LoginFeedback';
import LoginForm from './LoginForm';
import { LoginContainer, LoginWrapper } from './LoginWrapper';
import { LoginPageProps } from './types';
import warnings from './warnings.json';
import {
  withBranding,
  UNAUTHENTICATED,
  INTERSTITIAL,
} from '~/components/branding';
import { BRANDING_KEY } from '~/components/branding/constants';
import useBranded from '~/components/branding/useBranded';
import config from '~/config';
import { HEADING_SIZE } from '~/constants';

const LoginPage = (props: LoginPageProps) => {
  const { next, error } = props;
  const title = useBranded(BRANDING_KEY.LOGIN_PROMPT);

  return (
    <LoginWrapper>
      <Box height="3rem">
        <LoginFeedback error={error} />
      </Box>
      {title && (
        <Box mb="$7">
          <Heading size={HEADING_SIZE.LARGE} textAlign="center">
            {title}
          </Heading>
        </Box>
      )}
      <LoginForm next={next} />
    </LoginWrapper>
  );
};

type WarningText = { title: string; body: string[] };
type Warnings = Record<string, WarningText>;

const loadWarningText = (): WarningText => {
  const warningsTyped: Warnings = warnings;
  const id = config.LOGIN_WARNING_ID ?? 'DOD';
  const fallback = warnings.DOD;
  return warningsTyped[id] ?? fallback;
};

const IDPLogin = () => {
  const text = loadWarningText();
  const onClick = () => window.location.assign(config.SINGLE_IDP_URL);
  return (
    <LoginContainer width="30rem">
      <VStack alignItems="center">
        <Heading size="3">{text.title}</Heading>
        <VStack width="100%">
          {text.body.map((str: string, i: number) => (
            // eslint-disable-next-line react/no-array-index-key
            <Text key={i}>{str}</Text>
          ))}
        </VStack>
        <Button appearance="primary" onClick={onClick}>
          Continue
        </Button>
      </VStack>
    </LoginContainer>
  );
};

export default config.SINGLE_IDP_URL
  ? withBranding(INTERSTITIAL)(IDPLogin)
  : withBranding(UNAUTHENTICATED)(LoginPage);
